module.exports = __webpack_public_path__ + "img/wood-texture_00018.6fe6b2c8.png";